import { jsx as e, jsxs as n } from "react/jsx-runtime";
import { AmpcoreMaterialIconId as i } from "@ampcore/ampcom-contracts";
import { MaterialIcon as l } from "../MaterialIcon/MaterialIcon.mjs";
const C = (o) => {
  const {
    prevBtnClassNames: d = "",
    handlePrevPageBtn: c,
    heading: s = "Side Panel Heading",
    minimizable: r = !1,
    isMinimized: m,
    toggleMinimized: u,
    handleClose: h,
    showPrevButton: p = !1,
    isOnPrevPage: t = !1,
    testId: a
  } = o, N = m ? "Maximize panel" : "Minimize panel to bottom corner", P = "SidePanel-header" + (t ? " SidePanel-header-prev" : ""), g = "SidePanel-heading" + (t ? " SidePanel-heading-prev" : "");
  return /* @__PURE__ */ e("header", { className: "SidePanel-headerWrapper", children: /* @__PURE__ */ n("div", { className: P, children: [
    /* @__PURE__ */ n("div", { className: g, children: [
      p && /* @__PURE__ */ n(
        "button",
        {
          className: d,
          type: "button",
          title: "Previous page in panel",
          onClick: c,
          children: [
            /* @__PURE__ */ e("span", { className: "u-hiddenVisually", children: "Previous page in panel" }),
            /* @__PURE__ */ e(
              l,
              {
                icon: i.ARROW_BACK_IOS,
                className: "u-colorBrandIcon u-marginLeftM4"
              }
            )
          ]
        }
      ),
      typeof s == "string" ? /* @__PURE__ */ e("h2", { className: "SidePanel-headingContent", children: s }) : /* @__PURE__ */ e("div", { className: "SidePanel-headingContent", children: s })
    ] }),
    /* @__PURE__ */ n("div", { className: "SidePanel-icons", children: [
      r && /* @__PURE__ */ n(
        "button",
        {
          className: "Button Button--icon Button--icon--neutral SidePanel-Button--minimize",
          title: N,
          type: "button",
          onClick: u,
          "data-testid": a ? `${a}-minimize-panel` : void 0,
          children: [
            /* @__PURE__ */ n("span", { className: "SidePanel-minimizeIcon", children: [
              /* @__PURE__ */ e("span", { className: "u-hiddenVisually", children: "Minimize panel to bottom corner" }),
              /* @__PURE__ */ e(
                l,
                {
                  icon: i.COLLAPSE_ALL,
                  className: "u-colorBrandIcon u-marginLeftM4"
                }
              )
            ] }),
            /* @__PURE__ */ n("span", { className: "SidePanel-maximizeIcon", children: [
              /* @__PURE__ */ e("span", { className: "u-hiddenVisually", children: "Maximize panel" }),
              /* @__PURE__ */ e(
                l,
                {
                  icon: i.EXPAND_ALL,
                  className: "u-colorBrandIcon u-marginLeftM4"
                }
              )
            ] })
          ]
        }
      ),
      /* @__PURE__ */ n(
        "button",
        {
          className: "Button Button--icon Button--icon--neutral SidePanel-Button--close",
          title: "Close panel",
          type: "button",
          onClick: h,
          "data-testid": a ? `${a}-close-panel` : void 0,
          children: [
            /* @__PURE__ */ e("span", { className: "u-hiddenVisually", children: "Close panel" }),
            /* @__PURE__ */ e(
              l,
              {
                icon: i.CLOSE,
                className: "u-colorBrandIcon"
              }
            )
          ]
        }
      )
    ] })
  ] }) });
};
export {
  C as SidePanelHeader
};
//# sourceMappingURL=SidePanelHeader.mjs.map
